module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.fee66e71.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 721
// module chunks = 0